var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgClocki = function SvgClocki(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    d: "M12 1a11 11 0 1 0 11 11A11 11 0 0 0 12 1m0 19.87A8.87 8.87 0 1 1 20.87 12 8.87 8.87 0 0 1 12 20.87m2.74-4.63-3.76-2.74a.54.54 0 0 1-.22-.43V5.79a.53.53 0 0 1 .53-.53h1.42a.53.53 0 0 1 .53.53v6.28l2.96 2.16a.53.53 0 0 1 .11.75l-.83 1.15a.54.54 0 0 1-.74.11"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgClocki);
export default ForwardRef;